import http from "../http";

export async function getBusinessById(portfolioId, data) {
  const response = await http.get(`/monitoring/business?epPortfoliosId=${portfolioId}`, data);
  return response.data;
}

export async function postBusiness(data) {
  const response = await http.post("/monitoring/business", data);
  return response.data;
}

export async function approveBusiness(data) {
  const response = await http.post("/monitoring/business/approval-request", data);
  return response.data;
}

export async function getPortfolios(data) {
  const response = await http.get("/monitoring/portfolio", data);
  return response.data;
}
